import { useTranslation } from "react-i18next";

const icons = [
  "ri-team-line",
  "ri-archive-drawer-line",
  "ri-money-euro-circle-line",
  "ri-shield-check-line",
];

export default function WaaromWij() {
  const { t } = useTranslation("home");
  const reasons = t("waarom.reasons", { returnObjects: true }) as Array<{
    nr: string;
    title: string;
    desc: string;
  }>;

  return (
    <section id="waarom" className="bg-brand-cream py-20 md:py-[120px] w-full">
      <div className="max-w-[1400px] mx-auto px-4 md:px-10">
        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <h2 className="font-geist font-bold text-3xl md:text-[48px] text-brand-text mb-4">
            {t("waarom.h2")}
          </h2>
          <p className="font-geist text-base md:text-lg text-brand-text/60 max-w-[600px] mx-auto">
            Sinds 2015 helpen wij woningeigenaren en VvE's in Eindhoven met vakkundige reparatie en eerlijk advies.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {reasons.map((r, i) => (
            <div
              key={r.nr}
              className="group bg-white rounded-2xl border border-brand-border p-8 md:p-10 transition-all duration-300 hover:-translate-y-1 hover:border-brand-yellow/50 hover:shadow-lg hover:shadow-brand-yellow/10"
            >
              {/* Top row: number + icon */}
              <div className="flex items-center justify-between mb-6">
                <span className="font-geist-mono text-[64px] md:text-[80px] leading-none text-brand-yellow/80 font-bold">
                  {r.nr}
                </span>
                <div className="w-14 h-14 rounded-xl bg-brand-cream flex items-center justify-center transition-colors duration-300 group-hover:bg-brand-yellow/20">
                  <i className={`${icons[i]} w-7 h-7 flex items-center justify-center text-brand-text text-[28px]`}></i>
                </div>
              </div>

              {/* Title */}
              <h3 className="font-geist font-bold text-xl md:text-[24px] text-brand-text mb-3">
                {r.title}
              </h3>

              {/* Description */}
              <p className="font-geist text-base text-brand-text/70 leading-relaxed">
                {r.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}